<template>
  <v-card outlined class="report-section-card mb-3">
    <v-card-text class="pa-4">
      <div>
        <div class="section-title">Inventory</div>
        <div class="section-subtitle">Inventory value and serial reports</div>
      </div>

      <div class="report-list mt-3">
        <div class="report-item" @click="openReportWithDate('serial')">
          <div class="report-icon-box"><v-img src="@/assets/Report/barcode.png" /></div>
          <div class="report-item-title">Serial Balance By Date</div>
          <v-icon color="#94a3b8">mdi-calendar</v-icon>
        </div>

        <div class="report-item" @click="openReport('availableSerial')">
          <div class="report-icon-box"><v-img src="@/assets/Report/buyer.png" /></div>
          <div class="report-item-title">Available Serial</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>

        <div class="report-item" @click="openDateSelector('inventory/soldSerial')">
          <div class="report-icon-box"><v-img src="@/assets/Report/buyer.png" /></div>
          <div class="report-item-title">Serials Marked Sold</div>
          <v-icon color="#94a3b8">mdi-calendar-range</v-icon>
        </div>

        <div class="report-item" @click="openReport('inventoryValue')">
          <div class="report-icon-box"><v-img src="@/assets/Report/deficit.png" /></div>
          <div class="report-item-title">Inventory Valuation</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>
      </div>
    </v-card-text>

    <v-dialog v-model="custom" width="460">
      <v-card class="custom-date-card">
        <div class="custom-date-header">
          <div>
            <div class="custom-date-title">Custom Date</div>
            <div class="custom-date-subtitle">Select the inventory balance date.</div>
          </div>

          <v-btn icon small @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4">
          <v-menu
            ref="startMenu"
            v-model="startMenu"
            :close-on-content-click="false"
            :return-value.sync="startDateDisplay"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-on="on"
                dense
                hide-details
                v-model="startDateDisplayNormal"
                label="Date"
                readonly
                clearable
              />
            </template>

            <v-date-picker v-model="startDate" scrollable>
              <v-spacer />
              <v-btn text color="primary" @click.stop.prevent="startMenu = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click.stop.prevent="$refs.startMenu.save(startDateDisplay)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn rounded text @click="cancel">Cancel</v-btn>
          <v-btn
            rounded
            color="primary"
            dark
            :disabled="!startDateDisplayNormal"
            @click.stop.prevent="submit"
          >
            Go
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "report-inventory",

  data() {
    return {
      selectedDate: null,
      startMenu: false,
      start: {
        date: null,
        time: null,
      },
      custom: false,
      link: null,
    };
  },

  computed: {
    startDateDisplayNormal: {
      get() {
        return this.start.date ? this.start.date.format("MM/DD/YYYY") : null;
      },
      set() {
        this.start.time = null;
        this.start.date = null;
      },
    },

    startDate: {
      get() {
        return this.start.date ? this.start.date.format("YYYY-MM-DD") : null;
      },
      set(val) {
        this.start.date = val ? this.$moment(val) : null;
      },
    },

    startDateDisplay: {
      get() {
        return this.start.date ? this.start.date.format("MM/DD/YYYY") : null;
      },
      set(val) {
        if (val) {
          const newDate = new Date(val).toISOString();
          this.startDate = this.$moment(newDate).format("YYYY-MM-DD");
        } else {
          this.startDate = null;
          this.start.time = null;
        }
      },
    },
  },

  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),

    cancel() {
      this.custom = false;
    },

    submit() {
      let date = null;

      if (this.start.date) {
        date = this.start.date.startOf("day").toISOString();
      }

      this.selectedDate = date;

      const routeData = this.$router.resolve({
        path: `/reportView/inventory/${this.link}?date=${this.selectedDate}`,
      });

      window.open(routeData.href, "_blank");
      this.custom = false;
    },

    openReportWithDate(link) {
      this.custom = true;
      this.link = link;
    },

    openReport(link) {
      const routeData = this.$router.resolve({ path: `/reportView/inventory/${link}` });
      window.open(routeData.href, "_blank");
    },

    openDateSelector(reportName) {
      this.setReportName(reportName);
      this.setDateSelector(true);
    },
  },
};
</script>

<style scoped>
.report-section-card { border-radius: 20px; background: #ffffff; }
.section-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.section-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
.report-list { display: grid; gap: 8px; }
.report-item { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 16px; background: #f8fafc; cursor: pointer; transition: 0.2s ease; }
.report-item:hover { background: #eef2ff; }
.report-icon-box { width: 38px; height: 38px; min-width: 38px; border-radius: 12px; background: #ffffff; padding: 7px; display: flex; align-items: center; justify-content: center; }
.report-item-title { flex: 1; font-size: 14px; font-weight: 700; color: #0f172a; }
.custom-date-card { border-radius: 20px; overflow: hidden; }
.custom-date-header { padding: 16px; display: flex; align-items: center; justify-content: space-between; gap: 16px; border-bottom: 1px solid #e2e8f0; background: #f8fafc; }
.custom-date-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.custom-date-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
</style>
